<div class="consequence-details">
  @if (hasConsequencesData()) {
  @if (hasTargetRouteImpact()) {
    <div class="section">
      <div class="section-title"><img src="./assets/image/target.svg" alt="target-route">Target Route
      </div>
      <div class="route-card target-route">
        <div class="route-header">
          <span class="route-name me-1">
            {{ consequencesMetrics?.targetRouteImpact?.routeLabel ?? consequencesMetrics?.targetRouteImpact?.routeId ?? 'Route' }}
            <p-tag class="ms-2 warning-chip" [value]="consequencesMetrics?.targetRouteImpact?.routeState" severity="warn" />
          </span>
        </div>
        <div class="metrics before-after-metrics">
          <span class="metric">
            <img src="./assets/image/Item_dark.svg" alt="item" class="icon-class" height="16" width="16">
            <span class="metric-block">
              <span class="metric-row"><span class="metric-key">Before</span><b>{{ consequencesMetrics?.targetRouteImpact?.metricsBeforeMove?.itemCount ?? '-' }}</b> Items</span>
              <span class="metric-row"><span class="metric-key">After</span><b>{{ consequencesMetrics?.targetRouteImpact?.metricsAfterMove?.itemCount ?? '-' }}</b> Items</span>
            </span>
          </span>
          <span class="metric">
            <img src="./assets/image/Weight.svg" alt="weight" class="icon-class" height="16" width="16">
            <span class="metric-block">
              <span class="metric-row"><span class="metric-key">Before</span><b>{{ consequencesMetrics?.targetRouteImpact?.metricsBeforeMove?.totalWeight | gramsToKg }}</b> kg</span>
              <span class="metric-row"><span class="metric-key">After</span><b>{{ consequencesMetrics?.targetRouteImpact?.metricsAfterMove?.totalWeight | gramsToKg }}</b> kg</span>
            </span>
          </span>
          <span class="metric">
            <img src="./assets/image/stop_.svg" alt="stops" class="icon-class" height="16" width="16">
            <span class="metric-block">
              <span class="metric-row"><span class="metric-key">Before</span><b>{{ consequencesMetrics?.targetRouteImpact?.metricsBeforeMove?.stopCount ?? '-' }}</b> Stops</span>
              <span class="metric-row"><span class="metric-key">After</span><b>{{ consequencesMetrics?.targetRouteImpact?.metricsAfterMove?.stopCount ?? '-' }}</b> Stops</span>
            </span>
          </span>
          <span class="metric">
            <img src="./assets/image/Task_dark.svg" alt="tasks" class="icon-class" height="16" width="16">
            <span class="metric-block">
              <span class="metric-row"><span class="metric-key">Before</span><b>{{ consequencesMetrics?.targetRouteImpact?.metricsBeforeMove?.taskCount ?? '-' }}</b> Tasks</span>
              <span class="metric-row"><span class="metric-key">After</span><b>{{ consequencesMetrics?.targetRouteImpact?.metricsAfterMove?.taskCount ?? '-' }}</b> Tasks</span>
            </span>
          </span>
        </div>
      </div>
    </div>
  }
  @if (hasMoveTaskMetrics()) { 
    <div class="section">
      <div class="section-title"><img src="./assets/image/total_sum.svg" alt="total-kpi">Total KPI
        Impact</div>
      <div class="route-card total-kpi-card">
        <div class="metrics">
          <span><img src="./assets/image/Item_dark.svg" alt="item" class="icon-class" height="16" width="16"><b>{{ consequencesMetrics?.moveTaskMetrics?.itemCount ?? '-' }}</b> Items</span>
          <span><img src="./assets/image/Weight.svg" alt="weight" class="icon-class" height="16" width="16"><b>{{ consequencesMetrics?.moveTaskMetrics?.totalWeight | gramsToKg }}</b> kg</span>
          <span><img src="./assets/image/stop_.svg" alt="stops" class="icon-class" height="16" width="16"><b>{{ consequencesMetrics?.moveTaskMetrics?.stopCount ?? '-' }}</b> Stops</span>
          <span><img src="./assets/image/Task_dark.svg" alt="tasks" class="icon-class" height="16" width="16"><b>{{ consequencesMetrics?.moveTaskMetrics?.taskCount ?? '-' }}</b> Tasks</span>
        </div>
      </div>
    </div>
  }
  @if (hasSourceRoutesImpact()) {
    <div class="section">
      <div class="section-title"><img src="./assets/image/source.svg" alt="source-route">Source Routes
        ({{ (consequencesMetrics?.sourceRoutesImpact?.length ?? 0) }})
      </div>
      <div class="source-routes-scroll">
        @if(consequencesMetrics?.sourceRoutesImpact?.length){
        @for(route of consequencesMetrics.sourceRoutesImpact; track route.routeId) {
        <div class="route-card source-route">
          <div class="route-header">
            <span class="route-name">{{ route.routeLabel ?? route.routeId }}<p-tag styleClass="ms-2 primary-chip" [value]="route.routeState" severity="info"></p-tag> </span>
          </div>
          <div class="metrics before-after-metrics">
            <span class="metric">
              <img src="./assets/image/Item_dark.svg" alt="item" class="icon-class" height="16" width="16">
              <span class="metric-block">
                <span class="metric-row"><span class="metric-key">Before</span><b>{{ route.metricsBeforeMove?.itemCount ?? '-' }}</b> Items</span>
                <span class="metric-row"><span class="metric-key">After</span><b>{{ route.metricsAfterMove?.itemCount ?? '-' }}</b> Items</span>
              </span>
            </span>
            <span class="metric">
              <img src="./assets/image/Weight.svg" alt="weight" class="icon-class" height="16" width="16">
              <span class="metric-block">
                <span class="metric-row"><span class="metric-key">Before</span><b>{{ route.metricsBeforeMove?.totalWeight | gramsToKg }}</b> kg</span>
                <span class="metric-row"><span class="metric-key">After</span><b>{{ route.metricsAfterMove?.totalWeight | gramsToKg }}</b> kg</span>
              </span>
            </span>
            <span class="metric">
              <img src="./assets/image/stop_.svg" alt="stops" class="icon-class" height="16" width="16">
              <span class="metric-block">
                <span class="metric-row"><span class="metric-key">Before</span><b>{{ route.metricsBeforeMove?.stopCount ?? '-' }}</b> Stops</span>
                <span class="metric-row"><span class="metric-key">After</span><b>{{ route.metricsAfterMove?.stopCount ?? '-' }}</b> Stops</span>
              </span>
            </span>
            <span class="metric">
              <img src="./assets/image/Task_dark.svg" alt="tasks" class="icon-class" height="16" width="16">
              <span class="metric-block">
                <span class="metric-row"><span class="metric-key">Before</span><b>{{ route.metricsBeforeMove?.taskCount ?? '-' }}</b> Tasks</span>
                <span class="metric-row"><span class="metric-key">After</span><b>{{ route.metricsAfterMove?.taskCount ?? '-' }}</b> Tasks</span>
              </span>
            </span>
          </div>
        </div>
        }
        }
      </div>
    </div>
  }
  }
  @else {
    <div class="no-data-state text-center">
      <div class="no-data-title">No consequences data available</div>
      <div class="no-data-subtitle">Try again or adjust your selection.</div>
    </div>
  }
</div>

<ng-template #dialogFooter>
  <button class="pn-button pn-button-tertiary pn-button-md me-2" (click)="close()">Cancel</button>
  <button class="pn-button pn-button-primary pn-button-md me-1" [disabled]="!hasConsequencesData()" (click)="moveTask()">Move Task <img src="./assets/image/Arrow.svg" alt="move-task-arrow" height="15" width="15"></button>
</ng-template>